import { Route, Routes } from 'react-router-dom';

import Buyer from './Buyer';
import BuyerList from './BuyerList';

const BuyerRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<BuyerList />} />
            <Route path="/:id" element={<Buyer />} />
        </Routes>
    );
};

export default BuyerRoutes;
